import { IdmUtilities } from "./Idm-Utility.js";
export var StorageType = /*#__PURE__*/function (StorageType) {
  StorageType["LocalStorage"] = "localStorage";
  StorageType["SessionStorage"] = "sessionStorage";
  StorageType["Cookies"] = "cookies";
  return StorageType;
}(StorageType || {});
export class StorageManager {
  constructor(storage) {
    this.storage = storage;
    this.utility = new IdmUtilities();
  }
  setItem(key, value) {
    if (this.storage == StorageType.Cookies) {
      this.utility.writeCookie(key, value);
    } else {
      var stg = window[this.storage];
      stg.setItem(key, value);
    }
  }
  getItem(key) {
    if (this.storage == StorageType.Cookies) {
      return this.utility.readCookie(key);
    } else {
      var stg = window[this.storage];
      return stg.getItem(key);
    }
  }
  removeItem(key) {
    if (this.storage == StorageType.Cookies) {
      this.utility.deleteCookie(key);
    } else {
      var stg = window[this.storage];
      stg.removeItem(key);
    }
  }
}
